import script from "./MuffolaOwnership.vue?vue&type=script&setup=true&lang=js"
export * from "./MuffolaOwnership.vue?vue&type=script&setup=true&lang=js"

import "./MuffolaOwnership.vue?vue&type=style&index=0&id=5b2f42ba&lang=css"

const __exports__ = script;

export default __exports__